export var isArrayBuffer = function (arg) {
    return (typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer) ||
        Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/is-array-buffer/dist-es/index.js
// module id = 705
// module chunks = 0